export interface LoanFileTemplateData {
  id: number;
  nameTemplate: string;
  group?: string;
}

export type StatementGranularity = "month" | "year";
export type StatementFormat = "pdf" | "xlsx";

export interface OnDemandStatementRequest {
  granularity: StatementGranularity;
  year: number;
  month?: number;
  format?: StatementFormat;
}

// Numeric discriminator; mirrors the server enum.
export enum OnDemandStatementStatus {
  NoActivity = 0,
  Unavailable = 1,
  InvalidRequest = 2,
  Throttled = 3,
  Error = 4,
}

export interface OnDemandStatementEnvelope {
  status: OnDemandStatementStatus;
  // Generic, user-safe text — safe to display verbatim.
  message: string;
}

export type StatementDownloadResult =
  | { kind: "file"; blob: Blob; filename: string }
  | { kind: "status"; envelope: OnDemandStatementEnvelope };
